module.exports = __webpack_public_path__ + "img/goods13_5.cc14a4f9.jpg";